import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import QuestionBlock from '../GoalsFlow/QuestionBlock';
// import DebugData from '../shared/DebugData';
import { getSchemaFromGoal } from '../../constants/utils';
import Text from './Text';

const StyledFormContainer = styled.div`
  height: calc(100vh - 50px);
`;

const StyledForm = styled(Form)`
  overflow: hidden;
`;

const StyledErrorBlock = styled.div`
  color: red;
  opacity: 0;
  margin-top: -55px;
  display: none;

  ${({ show }) => show && css`
    display: block;
    opacity: 1;
  `}

  ${({ hide }) => hide && css`
    display: none;
    opacity: 0;
  `}
`;

const MasterForm = ({
  questionnaire,
  onQuestionFocus,
  onQuestionChange,
  onQuestionBlur,
  onStepSubmit,
  goToNextInput,
  isFinished,
  ...rest
}) => (
  <StyledFormContainer>
    {questionnaire.map((goal, index) => (
      <Formik
        validationSchema={Yup.object().shape({
          ...getSchemaFromGoal(goal),
        })}
        key={goal.value}
      >
        {props => (
          <StyledForm>
            <QuestionBlock
              goalIndex={index}
              goal={goal}
              form={props}
              isFocused={goal.isFocused}
              isAnswered={goal.isAnswered}
              onFocus={onQuestionFocus}
              onChange={onQuestionChange}
              onBlur={onQuestionBlur}
              totalQuestions={goal.questions.length}
              goToNextInput={goToNextInput}
              formIsValid={props.isValid}
              {...rest}
            />
            <StyledErrorBlock
              show={(isFinished && !props.isValid)}
              hide={(!isFinished || props.isValid)}
            >
              <Text type="errorMessage">Oops! Encontramos errores en una o más de las preguntas anteriores...</Text>
            </StyledErrorBlock>
            {/* <DebugData data={props} /> */}
          </StyledForm>
        )}
      </Formik>
    ))}
  </StyledFormContainer>
);


MasterForm.propTypes = {
  questionnaire: PropTypes.array,
  isFinished: PropTypes.bool,
  isValid: PropTypes.bool,
  onQuestionFocus: PropTypes.func,
  onQuestionChange: PropTypes.func,
  onQuestionBlur: PropTypes.func,
  onStepSubmit: PropTypes.func,
  goToNextInput: PropTypes.func,
};

MasterForm.defaultProps = {
  isValid: true,
  questionnaire: [],
  isFinished: false,
  onQuestionFocus: () => { },
  onQuestionChange: () => { },
  onQuestionBlur: () => { },
  onStepSubmit: () => { },
  goToNextInput: () => { },
};

export default MasterForm;
